<template>
	<div>
		<div @click="handleShow" class="suspension">查看规则</div>
		<div class="slide-page">
			<div class="paly-box">
				<div class="txt">您已完成显微镜判读考核，</div>
				<div class="txt">接下来将进入诊疗思路考核</div>
			</div>
			<div class="footer">
				<div @click="handleGoLuminance" class="left">进入考核</div>
			</div>
		</div>
		<van-popup v-model="isShow" position="bottom">
			<div class="gz">
				<div class="title">
					<div class="txt">环节介绍</div>
					<div @click="handleClose" class="close">
						<img src="./../../assets/home/closes.png" alt />
					</div>
				</div>
				<div class="img">
					<img class="icon" src="./../../assets/home/xssc3.png" alt />
					<!-- <image :src="baseStaticURL+'static/home/gz.png'" mode="widthFix"></image> -->
				</div>
			</div>
		</van-popup>
		<mi-xin></mi-xin>
	</div>
</template>
<script>
	import {
		mapMutations,
		mapState
	} from "vuex";
	import {
		getPetPaper
	} from "@/api/system/exam";
	import MiXin from "../mixins/index";
	import {
		submitExamCommitSingerAnswer
	} from "../../api/system/exam";
	export default {
		name: "Home2026",
		components: {
			MiXin,
			// TimeNum,
		},
		data() {
			return {
				type: 1,
				isShow: false,
				currentItem: null,
				visibles: false,
				petData: null,
				isLoading: false,
			};
		},
		created() {
			getPetPaper().then((response) => {
				sessionStorage.setItem("treatmentList", JSON.stringify(response.data
					.data));
				this.VISUAL_EXAMINATION({
					key: "treatmentList",
					value: response.data.data
				});

			});
		},
		mounted() {},
		computed: {
			...mapState("visualExamination", [
				//步骤二
				"detail",
				//步骤三
				"detailsz2",
				//步骤四
				"detail3",
				"detailstepPre3",
				//步骤五
				"detail4",
				//步骤六
				"detail5",
				"treatmentList",
				"treatmentEcho"
			]),
			...mapState("microscope", ["examDetailId"]),
		},
		methods: {
			// 关闭
			handleClose() {
				this.isShow = false;
			},

			// 打开
			handleShow() {
				this.isShow = true;
			},
			// 去下一步
			handleGoLuminance() {
				this.handleTreatGoStart();
			},
			...mapMutations("visualExamination", ["VISUAL_EXAMINATION"]),
			handleTreatGoStart() {
				let newArr = [
					...this.detail,
					...this.detailsz2,
					...this.detail3,
					...this.detailstepPre3,
					...this.detail4,
					...this.detail5,
				];
				const parmes = {
					paperId: this.treatmentList.id,
					details: newArr,
				};
				submitExamCommitSingerAnswer({
					backendAnswers: JSON.stringify(parmes),
					paperId: this.treatmentList.id || '',
					questionId: '-205',
					answers: JSON.stringify({
						detail: this.detail,
						detailsz2: this.detailsz2,
						detail3: this.detail3,
						detailstepPre3: this.detailstepPre3,
						detail4: this.detail4,
						detail5: this.detail5,
						treatmentEcho: this.treatmentEcho
					}),
					extractDetailId: this.examDetailId,
				}).then((response) => {
					this.$router.replace("/treat/Catalog");
				});

				// if (this.isLoading) {
				// 	return;
				// }
				// this.isLoading = true;
				// getPetPaper().then((response) => {
				// 	this.petData = response.data.data;
				// 	sessionStorage.setItem("treatmentList", JSON.stringify(this.petData));
				// 	this.VISUAL_EXAMINATION({
				// 		key: "treatmentList",
				// 		value: this.petData
				// 	});
				// 	this.visibles = false;
				// 	this.isLoading = false;
				// 	this.$router.replace("/treat/Catalog");
				// });
			},
		},
	};
</script>

<style lang="less" scoped>
	.van-popup {
		border-radius: 60px 60px 0 0;

		.dialog {
			position: relative;
			width: 100%;
			height: 1180px;
			overflow: auto;
			background: linear-gradient(182deg,
					rgba(105, 251, 251, 0.65),
					rgba(255, 255, 255, 0.65),
					rgba(255, 255, 255, 1),
					rgba(255, 255, 255, 1));

			.close {
				position: absolute;
				top: 54px;
				right: 55px;
				width: 49px;
			}

			.dialogTitle {
				padding-top: 50px;
				font-size: 50px;
				font-family: HarmonyOS Sans SC;
				font-weight: 500;
				color: #333333;
				text-align: center;
				margin-bottom: 38px;

				.link {
					vertical-align: middle;
					width: 50px;
					height: 50px;
					margin-right: 26px;
					margin-top: -8px;
				}
			}

			.itemTxt {
				display: flex;
				margin-bottom: 80px;

				.icon {
					width: 100%;
					margin-top: 20px;
				}
			}
		}
	}

	.suspension {
		position: fixed;
		top: 52px;
		right: 0;
		width: 176px;
		height: 72px;
		background: #043883;
		border-radius: 20px 0 0 20px;
		font-size: 28px;
		font-family: HarmonyOS Sans SC;
		font-weight: 500;
		color: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.slide-page {
		width: 100%;
		min-height: 100vh;
		background-image: url("./../../assets/home/xwjBg.png");
		background-repeat: no-repeat;
		background-size: 100% 100%;
		display: flex;
		align-items: center;
		justify-content: center;

		.txt {
			line-height: 50px;
			font-size: 32px;
			font-family: HarmonyOS Sans SC;
			font-weight: 400;
			color: #ffffff;
			text-align: center;
		}

		.footer {
			position: fixed;
			bottom: 0;
			width: 650px;
			height: 143px;
			background: linear-gradient(0deg, #ffffff, #e9f4f2);
			box-shadow: 0px -5px 50px 0px rgba(84, 84, 84, 0.07);
			border-radius: 60px 60px 0px 0px;
			padding: 40px 50px 0 50px;

			.left {
				width: 310px;
				margin: 0 auto;
				height: 88px;
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%);
				border: 1px solid #ffffff;
				box-shadow: 0px 0px 10px 0px rgba(36, 36, 36, 0.29);
				line-height: 88px;
				border-radius: 44px;
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: 500;
				color: #ffffff;
				text-align: center;
			}
		}

		.mask {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 1;
			background: rgba(255, 255, 255, 0.8);
		}

		.dialog {
			width: 612px;
			height: 440px;
			position: fixed;
			z-index: 2;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			margin: auto;

			background: #ffffff;
			box-shadow: 0px 30px 70px 0px rgba(13, 96, 103, 0.65);
			border-radius: 60px;

			.text {
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: bold;
				color: #333333;
				line-height: 60px;
				text-align: center;
			}

			.mt130 {
				margin-top: 120px;
			}

			.btn {
				width: 247px;
				margin: 0 auto;
				height: 80px;
				line-height: 80px;
				text-align: center;
				font-size: 35px;
				font-family: HarmonyOS Sans SC;
				font-weight: 500;
				margin-top: 80px;
				color: #ffffff;
				border-radius: 40px;
				background: linear-gradient(132.74deg,
						rgba(0, 187, 177, 1) 0%,
						rgba(0, 86, 140, 1) 74.31%,
						rgba(171, 59, 127, 1) 100%);
			}
		}
	}

	.gz {
		width: 750px;
		height: 1180px;
		border-radius: 16px 16px 0px 0px;
		background: linear-gradient(180deg,
				rgba(202, 247, 255, 1) 0%,
				rgba(255, 255, 255, 1) 100%);

		.title {
			padding: 40px 30px;
			position: relative;

			.txt {
				font-size: 40px;
				font-weight: 700;
				letter-spacing: 0px;
				line-height: 54.88px;
				color: rgba(51, 51, 51, 1);
				text-align: center;
				vertical-align: top;
			}

			.close {
				position: absolute;
				// right: 20px;
				// top: 40px;
                right: 43px;
				top: 56px;
				img {
					width: 24px;
				}
			}
		}

		.img {
			height: 1045px;
			overflow: auto;
			padding: 0 33px 33px 33px;

			img {
				width: 100%;
			}
		}
	}
</style>